<template>
  <v-app :class="$vuetify.theme.dark ? 'bg-metax' : 'white-bg'">
    <v-overlay :value="snackWithButtons">
      <v-card
        color="primary"
        :max-width="$vuetify.breakpoint.mdAndUp ? 500 : 300"
      >
        <v-card-title style="white--text word-break: normal">
          {{ snackWithBtnText }}</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="snackWithButtons = false">{{
            $t("notifications.buttons.dismiss")
          }}</v-btn>

          <v-btn color="success" @click.native="refreshApp">
            {{ snackBtnText }}</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-overlay>
    <v-overlay :value="deferredPrompt">
      <v-card
        :max-width="$vuetify.breakpoint.mdAndUp ? 500 : 300"
        color="primary"
        dark
      >
        <v-card-title style="word-break: normal">{{
          $t("notifications.messages.getOurApp")
        }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dismiss">{{
            $t("notifications.buttons.dismiss")
          }}</v-btn>

          <v-btn color="secondary" @click="install">{{
            $t("notifications.buttons.install")
          }}</v-btn></v-card-actions
        >
      </v-card>
    </v-overlay>
    <v-overlay :value="setState">
      <v-card
        :max-width="$vuetify.breakpoint.mdAndUp ? 500 : 300"
        color="primary"
        dark
      >
        <v-card-text class="title white--text"
          >{{ $t("notifications.messages.getOurAppIphone1") }}
          <v-icon>mdi-export-variant</v-icon>
          {{ $t("notifications.messages.getOurAppIphone2") }}</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dismissIos">{{
            $t("notifications.buttons.dismiss")
          }}</v-btn></v-card-actions
        >
      </v-card>
    </v-overlay>
    <!-- Layout component -->
    <component :is="currentLayout" v-if="isRouterLoaded">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </component>
    <!--   
    <v-main :class="$vuetify.theme.dark ? 'bg-metax' : 'white-bg'">
      <v-container class="mb-12" fluid>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main> -->
  </v-app>
</template>

<script>
import { db } from "./plugins/db.js";

// Layouts
import defaultLayout from "./layouts/DefaultLayout";
import simpleLayout from "./layouts/SimpleLayout";
import authLayout from "./layouts/AuthLayout";
import errorLayout from "./layouts/ErrorLayout";
/*
|---------------------------------------------------------------------
| Main Application Component
|---------------------------------------------------------------------
|
| In charge of choosing the layout according to the router metadata
|
*/
import NavigationBar from "./components/layout/NavigationBar";
import { mapState } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "App",
  computed: {
    ...mapState("auth", ["user"]),
    currentLayout: function() {
      const layout = this.$route.meta.layout || "default";

      return layout + "Layout";
    },
    isRouterLoaded: function() {
      if (this.$route.name !== null) return true;

      return false;
    }
  },
  components: {
    defaultLayout,
    NavigationBar,
    simpleLayout,
    authLayout,
    errorLayout
  },
  data() {
    return {
      deferredPrompt: null,
      disableBell: true,
      setState: null,
      refreshing: false,
      registration: null,
      snackBtnText: "",
      snackWithBtnText: "",
      snackWithButtons: false
    };
  },
  created() {
    if (!this.$store.getters["auth/isEmpty"]) {
      this.$root.$i18n.locale = this.user.language;
      this.$vuetify.theme.dark = this.user.theme;
    }
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  async mounted() {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      "standalone" in window.navigator && window.navigator.standalone;
    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      if (Cookies.get("add-to-home-screen") === undefined) {
        this.setState = true;
        Cookies.set("add-to-home-screen", null, { expires: 1 });
      } else {
        this.setState = false;
      }
    }
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (Cookies.get("add-to-home-screen") === undefined) {
        this.deferredPrompt = e;
      }
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },
  methods: {
    async dismissIos() {
      Cookies.set("add-to-home-screen", null, { expires: 1 });
      this.setState = false;
    },
    async dismiss() {
      Cookies.set("add-to-home-screen", null, { expires: 1 });
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    refreshApp() {
      this.snackWithButtons = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.snackBtnText = "Refresh";
      this.snackWithBtnText = this.$t("notifications.messages.updateAvailable");
      this.snackWithButtons = true;
    },

    cToF(actual) {
      return (Number(actual) * 1.8 + 32).toFixed(2);
    },
    async updateCustom() {
      /*      let variable = this.cToF(
        this.measurementProfile.planAPI53b.cCwOutTc53b
      ); */

      let snapshot = await db.collection("inspections").get();

      snapshot.forEach(doc => {
        let item = doc.data();
        console.log(
          "🚀 ~ file: App.vue ~ line 181 ~ updateCustom ~ item",
          item
        );
        db.collection("inspections")
          .doc(item.id)
          .update({
            media: []
          });
      });
    }
  }
};
</script>

<style scoped>
.white-bg {
  background-color: #e0e0e0 !important;
  background-image: url("./assets/eme-light.svg") !important;
  background-position: bottom 40px right 10px !important;
  background-size: 40% !important;
  background-repeat: no-repeat !important;
}
.bg-metax {
  background-image: url("./assets/eme.svg") !important;
  background-position: bottom right 10px !important;
  background-size: 40% !important;
  background-repeat: no-repeat !important;
}
.systembar {
  -webkit-user-select: none !important;
  -webkit-app-region: drag !important;
}
.systembar-buttom {
  -webkit-app-region: no-drag !important;
}

.overflow-ellipsis {
  text-overflow: ellipsis;
}

th {
  vertical-align: middle;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.snack >>> .v-snack__content {
  padding-right: 16px;
}
</style>
